<template>
  <TarjetaDatos titulo="Negocio Asegurado">
    <Campo2L :valor="poliza.nombreNeg" etiqueta="Nombre" />
    <Campo2L :valor="poliza.actividadNeg" etiqueta="Actividad" />
    <Campo2L :valor="poliza.direccionNeg" etiqueta="Dirección" />
    <Campo2L :valor="poliza.tipoNeg" etiqueta="Tipo" />
    <Campo2L v-if="poliza.infoActividadNeg" :valor="poliza.infoActividadNeg" etiqueta="Inf.Adicional" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
